export default __webpack_public_path__ + "static/media/faq.25c7fd6b.svg";